export const stripTag = (string: string): string =>
  string.replace(/(<([^>]+)>)/gi, '');
